import React from "react";
import { Container } from "../../../components";
import { Icon, Text, Heading } from "@telia/teddy";
import "./incompleteOrder.less";

const IncompleteOrderConfirmation = () => (
    <Container size="medium" className="incomplete-order-confirmation" noMargin>
        <Icon name="check-circle" className="incomplete-order-confirmation__check-icon" />
        <Heading mb="100" as="h2" variant="title-200">
            {"Bestillingsskjema er sent inn"}
        </Heading>
        <Text mb="100">Du vil bli kontaktet av oss så snart systemet er oppe igjen.</Text>
    </Container>
);

export default IncompleteOrderConfirmation;
